// extracted by mini-css-extract-plugin
export default {"input":"OutlinedInput_input__o8z-Z","multiline":"OutlinedInput_multiline__ICB4E"};